import React from "react";
import { Row, Col, Grid } from "antd";
import { useHistory } from "react-router-dom";
import styles from "./Footer.module.css";

const { useBreakpoint } = Grid;

const Footer = (props) => {
  const breakpoint = useBreakpoint();
  const history = useHistory();

  return (
    <div className={styles.footer}>
      <Row className="boxContainer" align="middle" style={{ height: "100%" }}>
        <Col span={6}>
          <div
            className={styles.textBtn}
            onClick={() => {
              history.push("/tnc");
            }}
          >
            {breakpoint?.md ? "Terms & Conditions" : "T&C"}
          </div>
        </Col>

        <Col span={12} style={{ textAlign: "center" }}>
          <div className={styles.text}>@ Live4Well 2024</div>
        </Col>

        <Col span={6} style={{textAlign: "right"}}>
          <div
            className={styles.textBtn}
            onClick={() => {
              history.push("/faq");
            }}
          >
            FAQ
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Footer;
